export const Types = {
  SEND_PASSWORD_LINK: 'SEND_PASSWORD_LINK',
  SEND_PASSWORD_LINK_SUCCESS: 'SEND_PASSWORD_LINK_SUCCESS',
  SEND_PASSWORD_LINK_FAIL: 'SEND_PASSWORD_LINK_FAIL',
  CLEAR_UI_STATE: 'FORGOT_PASSWORD/CLEAR_UI_STATE',
};

export const onSendPasswordLink = (email) => ({
  type: Types.SEND_PASSWORD_LINK,
  payload: { email },
});

export const onSendPasswordLinkSuccess = ({ codeDeliveryDetails = null } = {}) => ({
  type: Types.SEND_PASSWORD_LINK_SUCCESS,
  payload: { codeDeliveryDetails },
});

export const onSendPasswordLinkFail = (error) => ({
  type: Types.SEND_PASSWORD_LINK_FAIL,
  payload: { error },
});

export const clearUiState = () => ({
  type: Types.CLEAR_UI_STATE,
});

